export const ln1p = (x: number) => Math.log(1 + x);

export const clamp = (x: number, min: number, max: number) =>
  Math.min(max, Math.max(min, x));
